import React from 'react';
import { FaRocket, FaCheckCircle } from 'react-icons/fa';
import './Hero.css';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="hero" className="hero bg-gradient">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-dot"></span>
            Software 100% en la nube
          </div>
          
          <h1 className="hero-title">
            Software de Gestión Integral para{' '}
            <span className="title-highlight">Clubes Cannábicos</span>
          </h1>
          
          <p className="hero-subtitle">
            Gestión Club ofrece una solución completa y profesional para la administración
            de tu asociación cannábica. Control total de socios, stock, dispensario,
            contabilidad, accesos y mucho más.
          </p>

          <div className="hero-features">
            <div className="feature-item">
              <FaCheckCircle className="feature-icon" />
              <span>100% Basado en la nube</span>
            </div>
            <div className="feature-item">
              <FaCheckCircle className="feature-icon" />
              <span>Actualizaciones automáticas</span>
            </div>
            <div className="feature-item">
              <FaCheckCircle className="feature-icon" />
              <span>Soporte técnico incluido</span>
            </div>
          </div>

          <div className="hero-buttons">
            <button 
              className="btn btn-primary"
              onClick={() => scrollToSection('contacto')}
            >
              <FaRocket /> Solicitar Demo Gratuita
            </button>
            <button 
              className="btn btn-secondary"
              onClick={() => scrollToSection('servicios')}
            >
              Ver Funcionalidades
            </button>
          </div>
        </div>

        <div className="hero-image">
          <div className="image-card card-1">
            <div className="card-icon">👥</div>
            <div className="card-text">
              <div className="card-title">Gestión de Socios</div>
              <div className="card-value">+500 socios</div>
            </div>
          </div>
          
          <div className="image-card card-2">
            <div className="card-icon">🌿</div>
            <div className="card-text">
              <div className="card-title">Control de Stock</div>
              <div className="card-value">En tiempo real</div>
            </div>
          </div>
          
          <div className="image-card card-3">
            <div className="card-icon">💰</div>
            <div className="card-text">
              <div className="card-title">Contabilidad</div>
              <div className="card-value">Automática</div>
            </div>
          </div>

          <div className="floating-element element-1"></div>
          <div className="floating-element element-2"></div>
          <div className="floating-element element-3"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

